var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPFlight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_96_54846)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 7.29C10.5 7.11 10.405 6.945 10.255 6.845L6.5 4.5V1.75C6.5 1.335 6.165 1 5.75 1C5.335 1 5 1.335 5 1.75V4.5L1.245 6.845C1.095 6.94 1 7.11 1 7.29C1 7.64 1.34 7.895 1.68 7.79L5 6.75V9.5L4.1 10.175C4.035 10.22 4 10.295 4 10.375V10.67C4 10.835 4.16 10.955 4.32 10.91L5.75 10.5L7.18 10.91C7.34 10.955 7.5 10.835 7.5 10.67V10.375C7.5 10.295 7.465 10.22 7.4 10.175L6.5 9.5V6.75L9.82 7.79C10.16 7.895 10.5 7.64 10.5 7.29Z",
    stroke: "#798293",
    strokeWidth: 0.7
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_96_54846"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPFlight);
export default __webpack_public_path__ + "static/media/p_flight.aacc93b3510f0d8a134aa99c02d60c42.svg";
export { ForwardRef as ReactComponent };